export function numberToWords(num, currency = "Taka", subCurrency = null) {
  // Currency to subcurrency mapping
  const currencyMap = {
    // Major currencies
    USD: "Cents",
    AUD: "Cents",
    CAD: "Cents",
    NZD: "Cents",
    SGD: "Cents",
    HKD: "Cents",
    EUR: "Cents",
    GBP: "Pence",
    INR: "Paise",
    PKR: "Paisa",
    BDT: "Paisa",
    Taka: "Paisa",
    JPY: "Sen",
    CNY: "Fen",
    KRW: "Jeon",
    THB: "Satang",
    MYR: "Sen",
    IDR: "Sen",
    PHP: "Centavos",
    VND: "Xu",
    AED: "Fils",
    SAR: "Halalas",
    QAR: "Dirhams",
    KWD: "Fils",
    BHD: "Fils",
    OMR: "Baisa",
    JOD: "Piastres",
    ILS: "Agorot",
    TRY: "Kuruş",
    ZAR: "Cents",
    EGP: "Piastres",
    NGN: "Kobo",
    KES: "Cents",
    GHS: "Pesewas",
    RUB: "Kopeks",
    UAH: "Kopiykas",
    PLN: "Groszy",
    CZK: "Haléřů",
    HUF: "Fillér",
    RON: "Bani",
    CHF: "Rappen",
    SEK: "Öre",
    NOK: "Øre",
    DKK: "Øre",
    BRL: "Centavos",
    MXN: "Centavos",
    ARS: "Centavos",
    CLP: "Centavos",
    COP: "Centavos",
    PEN: "Céntimos",
  };

  // Auto-detect subcurrency if not provided
  if (!subCurrency) {
    subCurrency = currencyMap[currency] || "Cents";
  }

  if (!num || num === 0) return `Zero ${currency} Only`;

  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const convertLessThanThousand = (n) => {
    if (n === 0) return "";
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    if (n < 100)
      return (
        tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
      );
    return (
      ones[Math.floor(n / 100)] +
      " Hundred" +
      (n % 100 !== 0 ? " " + convertLessThanThousand(n % 100) : "")
    );
  };

  // Split into integer and decimal parts
  const numStr = parseFloat(num).toFixed(2);
  const [integerPart, decimalPart] = numStr.split(".");

  let number = parseInt(integerPart);
  let result = "";

  if (number >= 10000000) {
    const crore = Math.floor(number / 10000000);
    result += convertLessThanThousand(crore) + " Crore ";
    number %= 10000000;
  }

  if (number >= 100000) {
    const lakh = Math.floor(number / 100000);
    result += convertLessThanThousand(lakh) + " Lakh ";
    number %= 100000;
  }

  if (number >= 1000) {
    const thousand = Math.floor(number / 1000);
    result += convertLessThanThousand(thousand) + " Thousand ";
    number %= 1000;
  }

  if (number > 0) {
    result += convertLessThanThousand(number);
  }

  // Handle the main currency part
  if (result.trim() === "") {
    result = "Zero";
  }
  result = result.trim() + " " + currency;

  // Handle decimal part (subCurrency)
  const subCurrencyValue = parseInt(decimalPart);
  if (subCurrencyValue > 0) {
    const subCurrencyWords = convertLessThanThousand(subCurrencyValue);
    result += " " + subCurrencyWords + " " + subCurrency;
  }

  return result + " Only";
}
